import Vue from "vue";
import { Component } from "vue-property-decorator";
import { FetchWrapper } from "../../infrastructure/fetch-wrapper";

enum ConvergenceProviderType {
    awsBatch,
    inProcess,
    //local
}
interface IConvergenceProviderTypeWrapper {
    type: ConvergenceProviderType,
    name: string,
    identifier: string,
    index: number
}

@Component
export default class ConvergenceAdminIndex extends Vue {

    convergenceProviders: IConvergenceProviderTypeWrapper[] = [
        { type: ConvergenceProviderType.awsBatch, name: "AWS Batch", identifier: "awsBatch", index:0 },
        { type: ConvergenceProviderType.inProcess, name: "In-process", identifier: "inProcess", index: 1 },
//        { type: ConvergenceProviderType.local, name: "Local service", identifier: "local", index: 0 },
    ];
    currentConvergenceProvider: IConvergenceProviderTypeWrapper = this.convergenceProviders[0];


    // Todo: Check this opens the dashboard properly
    goToDashboard() {
               document.location.href = "/Hangfire";

    }

    mounted() {
        FetchWrapper.fetch("/api/1.0/query/getactiveconvergenceprovider", { method: "get" })
            .then(response => response.json())
            .then((response: ConvergenceProviderType) => {
                this.currentConvergenceProvider = this.convergenceProviders.find(p => p.index == response)
            });
    }

    changeConvergenceProvider(value: IConvergenceProviderTypeWrapper) {
        var payload = { newProvider: value.identifier };

        FetchWrapper.sendCommandAndHandle("/api/1.0/command/setactiveconvergenceprovider", { method: "post", body: JSON.stringify(payload) })
            .then(response => {
                if (response.success)
                    this.$root.$emit("activeConvergenceProviderChanged", value.identifier);
            })

    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/convergence-admin/convergence-admin-index.ts